/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { IIndependentVarProps } from './Model';
import { IAny } from '../../../../DashboardKPIWidgets/IEnergyManagementProps';
import { CheckboxIndependentVar } from './Checkbox/CheckboxVariable';
import {
  DropdownIndependentVar,
  IDropdownIndependentVarProps
} from './Dropdown/DropdownVariable';

export interface IIndependentVariablesComponentProps {
  independentVariables: IIndependentVarProps<IAny>[];
}

export const IndependentVariablesComponent = (
  props: IIndependentVariablesComponentProps
) => {
  return (
    <>
      {props.independentVariables.map((ivar, i) =>
        ivar.type === 'checkbox' ? (
          <CheckboxIndependentVar key={`checkbox-${i}`} {...ivar} />
        ) : ivar.type === 'dropdown' ? (
          <DropdownIndependentVar
            key={`dropdown-${i}`}
            {...(ivar as IDropdownIndependentVarProps)}
          />
        ) : (
          <></>
        )
      )}
    </>
  );
};
